import styled from 'styled-components';

export const StyledRightSide = styled.div`
    width: 66%;
    height: 100%;
`